import * as React from 'react';

import { SVGProps } from '../../types';

export const IconShieldCheckSvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-labelledby={titleId}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M19.25 5.99951C19.2499 5.93337 19.2235 5.86953 19.1768 5.82275C19.1299 5.77601 19.0662 5.74951 19 5.74951C16.7602 5.74951 14.1051 4.44928 12.2725 2.84912C12.1964 2.78428 12.0999 2.74951 12 2.74951C11.9001 2.74951 11.8036 2.78526 11.7275 2.8501C9.90555 4.4395 7.24026 5.74951 5 5.74951C4.9338 5.74951 4.87011 5.77601 4.82324 5.82275C4.77646 5.86953 4.75012 5.93337 4.75 5.99951V12.9995C4.75 15.3013 5.54673 16.9893 6.80762 18.2808C7.9289 19.4291 9.44352 20.2896 11.165 20.9565L11.915 21.231L11.9316 21.2368C11.9847 21.2566 12.0429 21.2574 12.0967 21.2397C14.1215 20.5336 15.9135 19.5958 17.1934 18.2827C18.4535 16.9897 19.25 15.3013 19.25 12.9995V5.99951ZM20.75 12.9995C20.75 15.6976 19.7964 17.7601 18.2666 19.3296C16.7573 20.878 14.7204 21.9141 12.5869 22.6577L12.5811 22.6606C12.2053 22.788 11.7976 22.7826 11.4248 22.6479C9.28579 21.9092 7.24527 20.876 5.73438 19.3286C4.20307 17.7602 3.25 15.6974 3.25 12.9995V5.99951C3.25012 5.53554 3.43461 5.09029 3.7627 4.76221C4.09086 4.43416 4.53598 4.24951 5 4.24951C6.75716 4.24951 9.08825 3.16342 10.7461 1.71533L10.7529 1.70947C11.1006 1.41255 11.5428 1.24951 12 1.24951C12.4001 1.24951 12.7885 1.37476 13.1123 1.60498L13.2471 1.70947L13.2539 1.71533C14.921 3.17282 17.2422 4.24951 19 4.24951C19.464 4.24951 19.9091 4.43416 20.2373 4.76221C20.5654 5.09029 20.7499 5.53555 20.75 5.99951V12.9995Z"
      fill="currentColor"
    />
    <path
      d="M14.4697 9.46969C14.7626 9.17679 15.2374 9.17679 15.5303 9.46969C15.8232 9.76258 15.8232 10.2373 15.5303 10.5302L11.5303 14.5302C11.2374 14.8231 10.7626 14.8231 10.4697 14.5302L8.46973 12.5302C8.17683 12.2373 8.17683 11.7626 8.46973 11.4697C8.76262 11.1768 9.23738 11.1768 9.53027 11.4697L11 12.9394L14.4697 9.46969Z"
      fill="currentColor"
    />
  </svg>
);
